import moment from "moment";

export function ChangeDay(number, t,isWeekOfMonth){
    if(number === 0){
        return 'nhất';
    }
    if(number === 1){
        return t('room.changeDay.2');
    }
    if(number === 2){
        return t('room.changeDay.3');
    }
    if(number === 3){
        return t('room.changeDay.4');
    }
    if(number === 4 && isWeekOfMonth){
        return t('room.changeDay.9');
    }
    if(number === 4){
        return t('room.changeDay.5');
    }
    if(number === 5){
        return t('room.changeDay.6');
    }
    if(number === 6){
        return t('room.changeDay.7');
    }
    if(number === 7){
        return t('room.changeDay.8');
    }

    return 0;
}

export function ChangeWeek(number, t,isWeekOfMonth){
    if(number === 0){
        return t('room.changeWeek.1');
    }
    if(number === 1){
        return t('room.changeWeek.2');
    }
    if(number === 2){
        return t('room.changeWeek.3');
    }
    if(number === 3){
        return t('room.changeWeek.4');
    }
    if(number === 4 ){
        return t('room.changeWeek.5');
    }

    return 0;
}

export function CreateDescPeriod(dataPeriod, t){
    
    let stringDesc = "";

    if(dataPeriod.time_profile_type_id === 1 && dataPeriod.start_time !== null){
        stringDesc = `${dataPeriod.interval === 1 ? t('room.desc-day.text2'): `${t('room.desc-day.text5')} ${dataPeriod.interval} ${t('room.desc-day.text3')}`} ${t('room.desc-day.text4')} ${moment(dataPeriod.end_time).format('DD/MM/YYYY')}`;
    } else if(dataPeriod.time_profile_type_id === 2 && dataPeriod.start_time !== null){
        if(dataPeriod.day?.length === 1){
            stringDesc = `${ChangeDay(dataPeriod.day[0], t)} ${dataPeriod.interval === 1 ? t('room.desc-week.text2'): `${t('room.desc-week.text7')} ${dataPeriod.interval} ${t('room.desc-week.text3')}`} ${t('room.desc-week.text4')} ${moment(dataPeriod.end_time).format('DD/MM/YYYY')}`
        } else if(dataPeriod.day?.length === 2){
            stringDesc = `${ChangeDay(dataPeriod.day[0], t)} ${t('room.desc-week.and')} ${ChangeDay(dataPeriod.day[1], t)} ${dataPeriod.interval === 1 ? t('room.desc-week.text2'): `${t('room.desc-week.text7')} ${dataPeriod.interval} ${t('room.desc-week.text3')}`} ${t('room.desc-week.text4')} ${moment(dataPeriod.end_time).format('DD/MM/YYYY')}`
        } else if(dataPeriod.day?.length === 3){
            stringDesc = `${ChangeDay(dataPeriod.day[0], t)}, ${ChangeDay(dataPeriod.day[1], t)} ${t('room.desc-week.and')} ${ChangeDay(dataPeriod.day[2], t)} ${dataPeriod.interval === 1 ? t('room.desc-week.text2'): `${t('room.desc-week.text7')} ${dataPeriod.interval} ${t('room.desc-week.text3')}`} ${t('room.desc-week.text4')} ${moment(dataPeriod.end_time).format('DD/MM/YYYY')}`
        } else if(dataPeriod.day?.length === 4){
            stringDesc = `${ChangeDay(dataPeriod.day[0], t)}, ${ChangeDay(dataPeriod.day[1], t)}, ${ChangeDay(dataPeriod.day[2], t)} ${t('room.desc-week.and')} ${ChangeDay(dataPeriod.day[3], t)} ${dataPeriod.interval === 1 ? t('room.desc-week.text2'): `${t('room.desc-week.text7')} ${dataPeriod.interval} ${t('room.desc-week.text3')}`} ${t('room.desc-week.text4')} ${moment(dataPeriod.end_time).format('DD/MM/YYYY')}`
        } else if(dataPeriod.day?.length === 5){
            stringDesc = `${ChangeDay(dataPeriod.day[0], t)}, ${ChangeDay(dataPeriod.day[1], t)}, ${ChangeDay(dataPeriod.day[2], t)}, ${ChangeDay(dataPeriod.day[3], t)} ${t('room.desc-week.and')} ${ChangeDay(dataPeriod.day[4], t)} ${dataPeriod.interval === 1 ? t('room.desc-week.text2'): `${t('room.desc-week.text7')} ${dataPeriod.interval} ${t('room.desc-week.text3')}`} ${t('room.desc-week.text4')} ${moment(dataPeriod.end_time).format('DD/MM/YYYY')}`
        } else if(dataPeriod.day?.length === 6){
            stringDesc = `${ChangeDay(dataPeriod.day[0], t)}, ${ChangeDay(dataPeriod.day[1], t)}, ${ChangeDay(dataPeriod.day[2], t)}, ${ChangeDay(dataPeriod.day[3], t)}, ${ChangeDay(dataPeriod.day[4], t)} ${t('room.desc-week.and')} ${ChangeDay(dataPeriod.day[5], t)} ${dataPeriod.interval === 1 ? t('room.desc-week.text2'): `${t('room.desc-week.text7')} ${dataPeriod.interval} ${t('room.desc-week.text3')}`} ${t('room.desc-week.text4')} ${moment(dataPeriod.end_time).format('DD/MM/YYYY')}`
        } else if(dataPeriod.day?.length === 7){
            stringDesc = `${ChangeDay(dataPeriod.day[0], t)}, ${ChangeDay(dataPeriod.day[1], t)}, ${ChangeDay(dataPeriod.day[2], t)}, ${ChangeDay(dataPeriod.day[3], t)}, ${ChangeDay(dataPeriod.day[4], t)}, ${ChangeDay(dataPeriod.day[5], t)} ${t('room.desc-week.and')} ${ChangeDay(dataPeriod.day[6], t)} ${dataPeriod.interval === 1 ? t('room.desc-week.text2'): `${t('room.desc-week.text7')} ${dataPeriod.interval} ${t('room.desc-week.text3')}`} ${t('room.desc-week.text4')} ${moment(dataPeriod.end_time).format('DD/MM/YYYY')}`
        }
    } else if(dataPeriod.time_profile_type_id === 3 && dataPeriod.start_time !== null){
        if(dataPeriod?.week){
            stringDesc = `${ChangeDay(dataPeriod?.day[0], t)} ${t('room.desc-monthly.text5')} ${ChangeWeek(dataPeriod.week - 1, t)} ${dataPeriod.interval === 1 ? t('room.desc-monthly.text2') : `${dataPeriod.interval} ${t('room.desc-monthly.text3')}`} ${t('room.desc-monthly.text4')} ${moment(dataPeriod.end_time).format('DD/MM/YYYY')}`
        } else if(dataPeriod.day?.length === 1) {
            stringDesc = `${dataPeriod?.day[0] === 32 ? t('room.desc-monthly.text6'): dataPeriod?.day[0]} ${dataPeriod.interval === 1 ? t('room.desc-monthly.text2') : `${dataPeriod.interval} ${t('room.desc-monthly.text3')}`} ${t('room.desc-monthly.text4')} ${moment(dataPeriod.end_time).format('DD/MM/YYYY')}`;
        }
    }
    return stringDesc;
}

function timeToSeconds(hours, minutes) {
    return hours * 3600 + minutes * 60;
}

export function roundTimeEndDay(){
    return moment().startOf('day').toDate();
}

export function roundTimeEndDayEvent(){
    return moment().add(1, 'days').startOf('day').toDate();
}
export function roundTimeEndSecond(){
    const currentMinute = parseInt(moment().startOf('minutes').add(2, 'hour').format('mm'));
    const _currentMinute = moment().startOf('minutes').add(2, 'hour');
    let between = 0;
    if(currentMinute < 15){
        between = 15 - currentMinute
    } else if(currentMinute < 30){
        between = 30 - currentMinute
    } else if(currentMinute < 45){
        between = 45 - currentMinute
    } else {
        between = 60 - currentMinute
    }

    const hourAndMinute = _currentMinute.add(between, 'minutes').format("HH:mm").split(":");
    const hour = parseInt(hourAndMinute[0]);
    const min = parseInt(hourAndMinute[1]);
    const second = timeToSeconds(hour, min);
    return second;
}

export function roundTimeEndSecondEvent(){
    const currentMinute = parseInt(moment().startOf('minutes').format('mm'));
    const _currentMinute = moment().startOf('minutes')
    let between = 0;
    if(currentMinute < 15){
        between = 15 - currentMinute
    } else if(currentMinute < 30){
        between = 30 - currentMinute
    } else if(currentMinute < 45){
        between = 45 - currentMinute
    } else {
        between = 60 - currentMinute
    }

    const hourAndMinute = _currentMinute.add(between, 'minutes').format("HH:mm").split(":");
    const hour = parseInt(hourAndMinute[0]);
    const min = parseInt(hourAndMinute[1]);
    const second = timeToSeconds(hour, min);
    return second;
}

export function roundTimeStartDay(){
    return moment().startOf('day').toDate();
}

export function roundTimeStartSecond(){
    const currentMinute = parseInt(moment().startOf('minutes').format('mm'));
    const _currentMinute = moment().startOf('minutes');
    let between = 0;
    if(currentMinute < 15){
        between = 15 - currentMinute
    } else if(currentMinute < 30){
        between = 30 - currentMinute
    } else if(currentMinute < 45){
        between = 45 - currentMinute
    } else {
        between = 60 - currentMinute
    }

    const hourAndMinute = _currentMinute.add(between, 'minutes').format("HH:mm").split(":");
    const hour = parseInt(hourAndMinute[0]);
    const min = parseInt(hourAndMinute[1]);
    const second = timeToSeconds(hour, min);
    return second;
}

export function convertUnixTimestampToSeconds(unixTimeStamp){
    const _currentMinute = moment.unix(unixTimeStamp).startOf('minutes');
    const hourAndMinute = _currentMinute.format("HH:mm").split(":");
    const hour = parseInt(hourAndMinute[0]);
    const min = parseInt(hourAndMinute[1]);
    const second = timeToSeconds(hour, min);
    return second;
}

export const convertSecondToHourAndMinute = (value) => {
    let totalSeconds = value
    let hours = Math.floor(totalSeconds / 3600);
    totalSeconds %= 3600;
    let minutes = Math.floor(totalSeconds / 60);

    if(hours < 10){
        hours = `0${hours}`
    }

    if(minutes < 10){
        minutes = `0${minutes}`
    }
    return `${hours}:${minutes}`
}

export const convertHourAndMinToSecond = (value) => {
    let validTime = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;

    if(validTime.test(value)){
        var a = value.split(':'); // split it at the colons
        // minutes are worth 60 seconds. Hours are worth 60 minutes.
        var seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60; 
        return seconds;
    } else return false;
}

export const generateUniqueString = () => {
    return crypto.randomUUID().replace(/-/g, '').substring(0, 10);
};

export function roundTimeStart(){
    let startTime = moment().startOf('minute');
    let plus15Minutes = startTime.minute() + 15;
    let number1 = plus15Minutes / 10;
    let roundNumber = Math.ceil(number1) * 10;
   
    return moment().startOf('minute').set('minute', roundNumber).toDate();
}

export function roundTimeEnd(){
    let startTime = moment().startOf('minute');
    let plus15Minutes = startTime.minute() + 15;
    let number1 = plus15Minutes / 10;
    let roundNumber = Math.ceil(number1) * 10;
   
    return moment().startOf('minute').add(2, 'hour').set('minute', roundNumber).toDate();
}

function padWithLeadingZeros(num, totalLength) {
    return String(num).padStart(totalLength, '0');
}

export function secondsToHoursMinutes(seconds, t) {
    // Calculate hours and minutes
    var hours = Math.floor(seconds / 3600);
    var minutes = Math.floor((seconds % 3600) / 60);

    

    // Format the result
    if(hours < 10){
        hours = padWithLeadingZeros(hours, 2)
    }

    if(minutes < 10){
        minutes = padWithLeadingZeros(minutes, 2)
    }

    var result = hours + " " + t('meeting.table.hour') + " " + minutes + " " + t('meeting.table.minute');

    if(parseInt(hours) < 0 || parseInt(minutes < 0) || (parseInt(hours) === 0 && parseInt(minutes) === 0)){
        return <span>
            {t('room.invalideTime')}
        </span>
    }
  
    return result;
}

export function secondsToMinutes(seconds){
    let minutes = Math.floor(seconds / 60);
    return minutes;
}

export function minuteToHourAndMinute(min, t){
    let hours = Math.floor(min / 60);
    let minutes = Math.floor((min % 60));

     // Format the result
     if(hours < 10){
        hours = padWithLeadingZeros(hours, 2)
    }

    if(minutes < 10){
        minutes = padWithLeadingZeros(minutes, 2)
    }

    var result = hours + " " + t('meeting.table.hour') + " " + minutes + " " + t('meeting.table.minute');

    if(parseInt(hours) < 0 || parseInt(minutes < 0) || (parseInt(hours) === 0 && parseInt(minutes) === 0)){
        return <span>
            {t('room.invalideTime')}
        </span>
    }
  
    return result;
}
